<section id="highlights" class="brand-highlights" appReveal>
  <div class="brand-highlights__inner">
    <header class="brand-highlights__header">
      <p class="section-label" i18n="@@highlights.eyebrow">品牌動態 Brand Highlights</p>
      <h2 class="brand-highlights__title font-display" i18n="@@highlights.title">媒體推介</h2>
    </header>

    <div class="brand-highlights__yt-grid">
      <a *ngFor="let v of youtubeVideos" class="brand-highlights__yt-card" [href]="youtubeUrl(v.id)" target="_blank" rel="noopener">
        <div class="brand-highlights__yt-thumb">
          <img [src]="youtubeThumb(v.id)" [alt]="v.title">
          <div class="brand-highlights__yt-play">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M8 5v14l11-7z"/></svg>
          </div>
        </div>
        <div class="brand-highlights__yt-meta">
          <h3 class="brand-highlights__yt-title">{{ v.title }}</h3>
          <div class="brand-highlights__yt-channel">
            <img [src]="v.channelAvatar" [alt]="v.channelName">
            <span>{{ v.channelName }}</span>
          </div>
        </div>
      </a>
    </div>

    <div class="brand-highlights__ig">
      <ngx-slick-carousel class="brand-highlights__ig-carousel" [config]="igSlideConfig">
        <div ngxSlickItem *ngFor="let p of igPosts" class="brand-highlights__ig-slide">
          <blockquote class="instagram-media" [attr.data-instgrm-permalink]="p.permalink" data-instgrm-version="14"
            style="background:#FFF;border:0;border-radius:12px;margin:0;max-width:540px;min-width:260px;padding:0;width:100%;">
          </blockquote>
        </div>
      </ngx-slick-carousel>
    </div>
  </div>
</section>
